import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { IUserRequest } from '../../interfaces/user-request';
import { BBWTMessageService } from '../../services';
import { UserRequestService } from '../../services';
import { UserPasswordSettings } from '../settings/settings';
import { sha512 } from '../../utils/hash';

@Component({
  selector: 'user-request-create-password',
  templateUrl: './user-request-create-password.component.html',
  styleUrls: ['user-request-create-password.component.scss'],
  providers: [],
})
export class UserRequestCreatePasswordComponent implements OnInit {
  public userRequestPasswordInfo = { password: '', confirmPassword: '' };
  public validCharacter = {
    lowercase: true,
    uppercase: true,
    numbers: false,
    special: false,
    minlength: 8,
  };
  public antiAutocomplete = true;
  public formInit = false;
  public ticket: string;
  public requestId: string;
  public initStatus: number = 0;

  public disableSubmitButton = false;

  constructor(
    private http: HttpClient,
    public router: Router,
    public messageService: BBWTMessageService,
    private userRequestService: UserRequestService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.getPasswordSettings();
    this.getAutoCompleteSettings();

    this.ticket = this.route.snapshot.params['ticket'];
    this.requestId = this.route.snapshot.params['requestId'];

    this.userRequestService
      .checkTicket(this.requestId, this.ticket)
      .then((result) => {
        // if (result == null) {
        //   this.initStatus = 2;
        //   this.messageService.ShowError('Load data', 'Nothing found on your request.');
        //   return;
        // }
        //
        // if (result.isExpired == true) {
        //   this.initStatus = 3;
        //   this.messageService.ShowWarning('Load data', 'Your ticket is outdated.');
        //   return;
        // }

        this.initStatus = 1;
      })
      .catch((ex) => {
        this.initStatus = 4;
        this.messageService.ShowError('Load data', 'An unexpected error occurred. Try again.');
      });
  }

  // Should be moved to settings service (not implemented yet)
  getPasswordSettings() {
    this.http
      .get<UserPasswordSettings>('/api/settings/passwordsettings/')
      .toPromise()
      .then((passwordSettings) => {
        if (passwordSettings != null && passwordSettings != undefined) {
          this.validCharacter.lowercase = passwordSettings.validCharacters.lowercase;
          this.validCharacter.uppercase = passwordSettings.validCharacters.uppercase;
          this.validCharacter.numbers = passwordSettings.validCharacters.digits;
          this.validCharacter.special = passwordSettings.validCharacters.punctuation;
          this.validCharacter.minlength = passwordSettings.minPasswordLength;
        }
      });
  }

  // Should be moved to settings service (not implemented yet) #settings_server
  getAutoCompleteSettings() {
    this.http
      .get('/api/settings/getautocomplete/', { responseType: 'text' })
      .toPromise()
      .then((autocomplete) => {
        if (autocomplete != null && autocomplete != undefined) {
          this.antiAutocomplete = !(autocomplete == 'true');
        } else {
          this.antiAutocomplete = true;
        }

        this.formInit = true;
      });
  }

  async onSubmit({ value }) {
    this.disableSubmitButton = true;
    var crpPassword = sha512(value.password);
    this.userRequestPasswordInfo.password = value.password;

    var passwordInfo = {
      userRequestId: this.requestId,
      ticket: this.ticket,
      password: crpPassword,
    };

    try {
      await this.userRequestService.createPassword(passwordInfo);
      this.messageService.ShowSuccess(
        'User Registration',
        'The user has been registered successfully.',
      );

      this.router.navigate(['/app/login']);
    } catch (e) {
      this.messageService.ShowError('User Registration', '');
    } finally {
      this.disableSubmitButton = false;
    }
  }
}
